'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  text-align: center;\n  padding: 0px 10px;\n  margin-top: 10px;\n'], ['\n  color: ', ';\n  text-align: center;\n  padding: 0px 10px;\n  margin-top: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  &:hover {\n    ', ' {\n      color: black;\n    }\n  }\n'], ['\n  &:hover {\n    ', ' {\n      color: black;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.15),\n    0px 1px 6px 0px rgba(0, 0, 0, 0.03)\n      ', ';\n'], ['\n  border-radius: 4px;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.15),\n    0px 1px 6px 0px rgba(0, 0, 0, 0.03)\n      ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n      , 0px 0px 0px 4px ', ';\n    '], ['\n      , 0px 0px 0px 4px ', ';\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  max-width: 1100px;\n  margin: 0px auto;\n  padding: 32px 12px 64px 12px;\n'], ['\n  max-width: 1100px;\n  margin: 0px auto;\n  padding: 32px 12px 64px 12px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: grid;\n\n  grid-column-gap: 20px;\n  grid-row-gap: 24px;\n  justify-content: center;\n\n  grid-template-columns: repeat(auto-fill, ', 'px);\n  grid-auto-flow: dense;\n'], ['\n  display: grid;\n\n  grid-column-gap: 20px;\n  grid-row-gap: 24px;\n  justify-content: center;\n\n  grid-template-columns: repeat(auto-fill, ', 'px);\n  grid-auto-flow: dense;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _controls = require('../controls');

var _controls2 = _interopRequireDefault(_controls);

var _slide = require('../slide');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var gridSlideWidth = 320;

var NavigationMode = function (_React$Component) {
  _inherits(NavigationMode, _React$Component);

  function NavigationMode(props) {
    _classCallCheck(this, NavigationMode);

    var _this = _possibleConstructorReturn(this, (NavigationMode.__proto__ || Object.getPrototypeOf(NavigationMode)).call(this, props));

    _this.loadSlide = function (index) {
      var loaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      _this.setState(function (state) {
        return {
          isSlideLoaded: _extends({}, state.isSlideLoaded, _defineProperty({}, String(index), loaded))
        };
      });
    };

    _this.handleSlideClick = function (index) {
      _this.props.switchSlide(index);
      _this.props.toggleBirdsEye();
    };

    _this.handleIntersection = function (entries, observer) {
      // Get the list of slides ids that are
      // currently visible within the viewport.
      var visible = entries.filter(function (entry) {
        return entry.isIntersecting;
      }).map(function (entry) {
        return entry.target.dataset.slideId;
      });

      visible.forEach(function (id) {
        return _this.loadSlide(id);
      });
    };

    _this.state = {
      isSlideLoaded: {}
    };
    return _this;
  }

  _createClass(NavigationMode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _window = window,
          IntersectionObserver = _window.IntersectionObserver;


      if (!IntersectionObserver || !this._root) {
        // Fallback for older browsers:
        // load everything up!
        this.props.slides.forEach(function (_, idx) {
          return _this2.loadSlide(idx);
        });
        return;
      }

      var options = {
        threshold: 0.5
      };

      this._observer = new IntersectionObserver(this.handleIntersection, options)

      // Fire observer up for slide items
      ;[].forEach.call(this._root.querySelectorAll('[data-slide-id]'), function (el) {
        return _this2._observer.observe(el);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _observer = this._observer;


      if (_observer && _observer.disconnect) {
        // Stop observing elements when unmounted
        _observer.disconnect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          slides = _props.slides,
          currentSlide = _props.currentSlide;


      return _react2.default.createElement(
        Container,
        { innerRef: function innerRef(el) {
            return _this3._root = el;
          } },
        _react2.default.createElement(
          Grid,
          null,
          slides.map(function (slide, index) {
            var isLoaded = !!_this3.state.isSlideLoaded[index.toString()];

            return _react2.default.createElement(
              SlideItem,
              {
                onClick: function onClick() {
                  return _this3.handleSlideClick(index);
                },
                key: index,
                'data-slide-id': index
              },
              _react2.default.createElement(SlideCard, {
                loaded: isLoaded,
                slide: slide,
                width: _this3.props.slideWidth,
                height: _this3.props.slideHeight,
                fitInto: { width: gridSlideWidth },
                isCurrent: currentSlide === index
              }),
              _react2.default.createElement(
                SlideName,
                null,
                slide.name
              )
            );
          })
        )
      );
    }
  }]);

  return NavigationMode;
}(_react2.default.Component);

var SlideName = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.darkGrayColor;
});

var SlideItem = _styledComponents2.default.div(_templateObject2, SlideName);

var SlideCard = (0, _styledComponents2.default)(_slide.Slide)(_templateObject3, function (props) {
  return props.isCurrent && (0, _styledComponents.css)(_templateObject4, function (props) {
    return props.theme.primaryColor;
  });
});

var Container = _styledComponents2.default.div(_templateObject5);

var Grid = _styledComponents2.default.div(_templateObject6, gridSlideWidth);

exports.default = NavigationMode;